export class OnboardAdditionalAzureApps200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OnboardAdditionalAzureApps200Response.attributeTypeMap;
    }
    constructor() {
    }
}
